import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomInput from "../../../../components/CustomInput";
import { getBanksList, createBankAccount } from "../../../../redux/actions/walletActions";
import { makeStyles } from "@material-ui/core/styles";

const StripeAddAccount = ({ handleClose }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedBankCode, setSelectedBankCode] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [banks, setBanks] = useState([]);

  const { bankList, accounts } = useSelector((state) => state.wallet);
  const [state, setState] = useState({
    accountName: "",
    accountNumber: "",
    bankName: "",
    routingNumber: "",
  });

  useEffect(() => {
    Promise.all([getBanksList(dispatch)]);
  }, [dispatch]);

  useEffect(() => {
    if (bankList && bankList.length > 0) {
      setBanks(bankList);
      console.log("Bank list loaded successfully:", bankList);
    } else {
      setBanks([]);
      console.log("Bank list is empty");
    }
  }, [bankList]);

  const handleChange = ({ target: { id, value } }) => {
    const newValue = {};
    newValue[id] = value;
    setState({ ...state, ...newValue });
  };

  const addAccount = async (evt) => {
    evt.preventDefault();
    setLoading(true);
    const bankData = {
      account_name: state.accountName,
      account_number: parseInt(state.accountNumber),
      bank: state.bankName,
      routing_number: state.routingNumber,
    };
    await createBankAccount(dispatch, bankData);
    setState({
      accountName: "",
      accountNumber: "",
      bankName: "",
      routingNumber: "",
    });
    handleClose();
    setLoading(false);
  };

  const isDisabled = !state.accountNumber || !state.accountName || !state.bankName;

  return (
    <div className={classes.root}>

      {/* Header */}
      <div className={classes.header}>
        <div className={classes.title}>Add bank account</div>
        <div className={classes.subtitle}>Enter your bank details below</div>
      </div>

      {/* Step indicators */}
      <div className={classes.steps}>
        <div className={classes.step}>
          <div className={classes.stepDot} style={{ background: "#3A6ED4" }} />
          <span className={classes.stepLabel} style={{ color: "#3A6ED4" }}>Account details</span>
        </div>
        <div className={classes.stepLine} />
        <div className={classes.step}>
          <div
            className={classes.stepDot}
            style={{ background: isDisabled ? "#D1D8E8" : "#3A6ED4" }}
          />
          <span
            className={classes.stepLabel}
            style={{ color: isDisabled ? "#B0BAC9" : "#3A6ED4" }}
          >
            Confirm
          </span>
        </div>
      </div>

      {/* Form */}
      <form className={classes.form} onSubmit={addAccount}>
        <CustomInput
          type="number"
          label="Account Number"
          id="accountNumber"
          isRequired={true}
          value={state.accountNumber}
          onChange={handleChange}
          placeholder="Enter account number"
        />
        <CustomInput
          type="text"
          label="Account Name"
          id="accountName"
          isRequired={true}
          value={state.accountName}
          onChange={handleChange}
          placeholder="Enter account holder name"
        />
        <CustomInput
          type="text"
          label="Bank Name"
          id="bankName"
          isRequired={true}
          value={state.bankName}
          onChange={handleChange}
          placeholder="Enter bank name"
        />
        <CustomInput
          type="text"
          label="Routing Number"
          id="routingNumber"
          isRequired={true}
          value={state.routingNumber}
          onChange={handleChange}
          placeholder="Enter routing number"
        />

        {/* Actions */}
        <div className={classes.actions}>
          <button
            type="button"
            className={classes.cancelBtn}
            onClick={handleClose}
          >
            Cancel
          </button>
          <div className={classes.submitWrap}>
            <CustomButton
              backgroundColor="#3A6ED4"
              color="#fff"
              text="Add Account"
              loading={loading}
              type="submit"
              handleClick={addAccount}
              disabled={isDisabled}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    padding: "8px 4px 16px",
  },
  header: {
    marginBottom: "20px",
  },
  title: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#032250",
  },
  subtitle: {
    fontSize: "13px",
    color: "#7F91A7",
    marginTop: "3px",
  },
  steps: {
    display: "flex",
    alignItems: "center",
    marginBottom: "24px",
  },
  step: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  stepDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    flexShrink: 0,
    transition: "background 0.2s",
  },
  stepLabel: {
    fontSize: "12px",
    fontWeight: 500,
    transition: "color 0.2s",
  },
  stepLine: {
    flex: 1,
    height: "1px",
    background: "#E2E8F0",
    margin: "0 10px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "20px",
  },
  cancelBtn: {
    padding: "10px 20px",
    borderRadius: "8px",
    border: "1px solid #D1D8E8",
    background: "transparent",
    color: "#7F91A7",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "background 0.15s",
    "&:hover": {
      background: "#F3F4F6",
    },
  },
  submitWrap: {
    flex: 1,
  },
});

export default StripeAddAccount;